'use strict';

angular.module('internal.licenses')
    .controller('InternalLicenseScheduledTaskDetails', ['$scope', '$window', '$state', 'LicenseScheduledTasks', 'LicenseCategories', 'IntegrationMethods', '$rootScope', 'UserStatuses', 'MergeTemplates', 'Enterprise', 'LicenseCategoryCertificationStatuses', function ($scope, $window, $state, LicenseScheduledTasks, LicenseCategories, IntegrationMethods, $rootScope, UserStatuses, MergeTemplates, Enterprise, LicenseCategoryCertificationStatuses) {
        $scope.resetLicense();
        $scope.isDetailsOpen = true;
        $scope.isCriteriaOpen = true;
        $scope.isActionsOpen = true;
        $scope.messages = [];
        $scope.saving = false;
        $scope.deleting = false;
        $scope.copying = false;
        $scope.integrationMethodOptions = [];
        $scope.code = null;
        $scope.licenseCategoryParameters = { 'current_license_category_id': $scope.licenseCategoryID }
        
        $scope.months = [
            { name: 'January', id: 1 },
            { name: 'February', id: 2 },
            { name: 'March', id: 3 },
            { name: 'April', id: 4 },
            { name: 'May', id: 5 },
            { name: 'June', id: 6 },
            { name: 'July', id: 7 },
            { name: 'August', id: 8 },
            { name: 'September', id: 9 },
            { name: 'October', id: 10 },
            { name: 'November', id: 11 },
            { name: 'December', id: 12 }
        ];

        $scope.frequencyTypeOptions = [
            { name: 'Day', id: 'Daily' },
            { name: 'Week', id: 'Weekly' },
            { name: 'Month', id: 'Monthly' }
        ];

        $scope.weekdays = [
            { name: 'Sunday', id: 'Sunday' },
            { name: 'Monday', id: 'Monday' },
            { name: 'Tuesday', id: 'Tuesday' },
            { name: 'Wednesday', id: 'Wednesday' },
            { name: 'Thursday', id: 'Thursday' },
            { name: 'Friday', id: 'Friday' },
            { name: 'Saturday', id: 'Saturday' }
        ];

        $scope.monthWeekdays = [
            { name: 'day', id: 'day' },
            { name: 'Sunday', id: 'Sunday' },
            { name: 'Monday', id: 'Monday' },
            { name: 'Tuesday', id: 'Tuesday' },
            { name: 'Wednesday', id: 'Wednesday' },
            { name: 'Thursday', id: 'Thursday' },
            { name: 'Friday', id: 'Friday' },
            { name: 'Saturday', id: 'Saturday' }
        ];

        $scope.monthDayOptions = [
            { name: 'first', id: 'first' },
            { name: 'nth', id: 'nth' },
            { name: 'last', id: 'last' }
        ];

        $scope.fromOptions = [
            { name: 'From', id: 'from' },
            { name: 'Exactly on', id: 'exact' }
        ];

        $scope.dayPartOptions = [
            { name: 'day(s)', id: 'day' },
            { name: 'month(s)', id: 'month' },
            { name: 'year(s)', id: 'year' }
        ];

        $scope.comparisonOptions = [
            { name: 'before', id: 'before' },
            { name: 'after', id: 'after' }
        ];

        $scope.serviceOptions = [
            { name: 'Does not have any affiliation', id: 'none' },
            { name: 'Must have at least one affiliation', id: 'any' }
        ];

        IntegrationMethods.get({ enterpriseID: $rootScope.enterpriseID }).then(function (integrationMethods) {
            if (integrationMethods != null) {
                integrationMethods.forEach(function (im) {
                    if (im.integration_method_type.name == 'Elite') {
                        $scope.integrationMethodOptions.push(im);
                    }
                })
            }
            //Add national registry certification option
            $scope.integrationMethodOptions.push({
                id: "verify_national_registry_certification", name: "Verify National Registry Certification"});
        });

        LicenseCategories.getByID($scope.licenseCategoryID).then(function (licenseCategory) {
            $scope.isUserEntity = licenseCategory.user_entity;
            $scope.isServiceEntity = licenseCategory.service_entity;
            $scope.isVehicleEntity = licenseCategory.vehicle_entity;
            $scope.scheduledTaskLicenseCategoryName = licenseCategory.name || "scheduled task";
            if ($scope.isUserEntity == true) {
                $scope.code = "Personnel";
            } else if ($scope.isServiceEntity == true) {
                $scope.code = "Service";
            } else if ($scope.isVehicleEntity == true) {
                $scope.code = "Vehicle";
            }

            if (licenseCategory.user_entity == true) {
                UserStatuses.get().then(function (userStatuses) {
                    $scope.recordStatuses = userStatuses;
                });
            } else {
                $scope.recordStatuses = [
                    { name: 'Active', id: true },
                    { name: 'Inactive', id: false }
                ];
            }

            MergeTemplates.get($scope.code).then(function (mergeTemplates) {
                $scope.mergeTemplates = mergeTemplates;
            });
        });

        $scope.setLicenseCategoryStatuses = function (licenseCategory) {
            //Set the certification statuses based on the license category
            if (licenseCategory) {
                if (licenseCategory == $scope.licenseCategoryID && $scope.scheduledTask.action_set_cert_issue_date == 'z') {
                    $scope.scheduledTask.action_set_cert_issue_date = 'i';
                }
                if (licenseCategory == $scope.licenseCategoryID && $scope.scheduledTask.action_set_cert_expiration_date == 'z') {
                    $scope.scheduledTask.action_set_cert_expiration_date = 'i';
                }
                if (licenseCategory != $scope.licenseCategoryID && $scope.scheduledTask.apply_cert_to_service_affiliation == true) {
                    $scope.scheduledTask.apply_cert_to_service_affiliation = false;
                }
                //Clear out status when license category is changed
                $scope.scheduledTask.action_certification_status = null;
                LicenseCategoryCertificationStatuses.get({ 'license_category_id': licenseCategory }).then(function (certificationStatuses) {
                    $scope.license_category_certification_statuses = certificationStatuses;
                });
            }
        };

        $scope.setFrequencyBeginTime = function (time) {
            if (time != null) {
                $scope.scheduledTask.frequency_begin_time = time.toLocaleTimeString('it-IT');
            }
        };

        $scope.setCriteriaCertIssueDate = function (a, b, c, d) {
            $scope.criteriaCertIssueDateIsRequired = (a || b || c || d) ? true : false;
        };

        $scope.setCriteriaCertExpirationDate = function (a, b, c, d) {
            $scope.criteriaCertExpirationDateIsRequired = (a || b || c || d) ? true : false;
        };

        $scope.setActionCertIssueDate = function (action_set_cert_issue_date) {
            if (action_set_cert_issue_date == 'r') {
                $scope.actionCertIssueDateReferenceDateIsRequired = true;
            } else {
                $scope.actionCertIssueDateReferenceDateIsRequired = false;
                $scope.scheduledTask.action_cert_issue_date_reference_date = null;
            }

            if (action_set_cert_issue_date == 'm') {
                $scope.actionCertIssueDateReferenceMonthIsRequired = true;
            } else {
                $scope.actionCertIssueDateReferenceMonthIsRequired = false;
                $scope.scheduledTask.action_cert_issue_date_reference_month = null;
            }
        };

        $scope.setActionCertExpirationDate = function (action_set_cert_expiration_date) {
            if (action_set_cert_expiration_date == 'i') {
                $scope.scheduledTask.action_cert_expiration_date_year_value = null;
            }

            if (action_set_cert_expiration_date == 'c') {
                $scope.scheduledTask.action_add_or_update_cert = false;
            }

            if (action_set_cert_expiration_date == 'r') {
                $scope.actionCertExpirationDateReferenceDateIsRequired = true;
            } else {
                $scope.actionCertExpirationDateReferenceDateIsRequired = false;
                $scope.scheduledTask.action_cert_expiration_date_reference_date = null;
            }

            if (action_set_cert_expiration_date == 'm') {
                $scope.actionCertExpirationDateReferenceMonthIsRequired = true;
            } else {
                $scope.actionCertExpirationDateReferenceMonthIsRequired = false;
                $scope.scheduledTask.action_cert_expiration_date_reference_month = null;
            }
        };

        $scope.save = function () {
            $scope.messages = [];
            if ($scope.scheduledTask && $scope.scheduledTask.frequency_type == null) {
                $scope.messages.push("Please enter a frequency type");
            } else if (!$scope.scheduledTask.frequency_type && $scope.scheduledTask.frequency_date_value != null) {
                $scope.messages.push("Please enter a frequency date type");
            } else {
                //Set verify national registry option
                if ($scope.scheduledTask.action_data_exchange == 'verify_national_registry_certification') {
                    $scope.scheduledTask.action_data_exchange = null;
                    $scope.scheduledTask.verify_national_registry = true;
                }
                else {
                    $scope.scheduledTask.verify_national_registry = false;
                }
                //Extra check to make sure apply certs to service affiliations is not on when it's not supposed to
                if ($scope.scheduledTask.action_license_category != $scope.licenseCategoryID || $scope.scheduledTask.action_set_cert_expiration_date == "z" || $scope.scheduledTask.action_set_cert_issue_date == "z") {
                    $scope.scheduledTask.apply_cert_to_service_affiliation = false;
                }
                $scope.saving = true;
                LicenseScheduledTasks.save($scope.scheduledTask).then(function (scheduledTask) {
                    $scope.scheduledTask = scheduledTask;
                    //Reset national registry option
                    if ($scope.scheduledTask.verify_national_registry == true) {
                        $scope.scheduledTask.action_data_exchange = 'verify_national_registry_certification';
                    }
                    Enterprise.get({ enterpriseID: $scope.scheduledTask.enterprise_id }).then(function (enterprise) {
                        $scope.enterprise = enterprise;

                        var timeString = $scope.scheduledTask.frequency_begin_time == null ? "12:00:00" : $scope.scheduledTask.frequency_begin_time.toString();
                        var begin_time_hours = timeString.substr(0, 2);
                        var begin_time_minutes = timeString.substr(timeString.indexOf(":") + 1, 2);
                        var begin_date_time_string = new Date(1900, 0, 1, parseInt(begin_time_hours), parseInt(begin_time_minutes)).toString();
                        var locale_date_string = new Date(begin_date_time_string).toLocaleString();
                        var frequency_begin_date = new Date(locale_date_string);

                        Date.prototype.addHours = function (h) {
                            this.setTime(this.getTime() + (h * 60 * 60 * 1000));
                            return this;
                        }

                        frequency_begin_date.addHours($scope.enterprise.server_spec.utc_to_server_hours);
                        $scope.scheduledTask.frequency_begin_date = frequency_begin_date;

                        // British English uses 24-hour time without AM/PM
                        var frequency_begin_time = frequency_begin_date.toLocaleTimeString('en-GB');
                        $scope.scheduledTask.frequency_begin_time = frequency_begin_time;

                        $scope.criteriaCertIssueDateIsRequired = (scheduledTask.certification_issue_date_comparison_type || scheduledTask.certification_issue_date_part_value || scheduledTask.certification_issue_date_part || scheduledTask.certification_issue_date_comparison_operator) ? true : false;
                        $scope.criteriaCertExpirationDateIsRequired = (scheduledTask.certification_expiration_date_comparison_type || scheduledTask.certification_expiration_date_part_value || scheduledTask.certification_expiration_date_part || scheduledTask.certification_expiration_date_comparison_operator) ? true : false;

                        if ($scope.scheduledTask.action_license_category == null) {
                            $scope.scheduledTask.action_license_category = $scope.licenseCategoryID;
                        }
                        if ($scope.scheduledTask.action_add_or_update_cert == null) {
                            $scope.scheduledTask.action_add_or_update_cert = 0;
                        }

                        if ($scope.scheduledTask.action_set_cert_issue_date == null) {
                            $scope.scheduledTask.action_set_cert_issue_date = 'i';
                        }
                        $scope.actionCertIssueDateReferenceDateIsRequired = (scheduledTask.action_set_cert_issue_date == 'r') ? true : false;
                        $scope.actionCertIssueDateReferenceMonthIsRequired = (scheduledTask.action_set_cert_issue_date == 'm') ? true : false;

                        if ($scope.scheduledTask.action_set_cert_expiration_date == null) {
                            $scope.scheduledTask.action_set_cert_expiration_date = 'i';
                        }
                        $scope.actionCertExpirationDateReferenceDateIsRequired = (scheduledTask.action_set_cert_expiration_date == 'r') ? true : false;
                        $scope.actionCertExpirationDateReferenceMonthIsRequired = (scheduledTask.action_set_cert_expiration_date == 'm') ? true : false;

                        updateArray($scope.license.license_scheduled_tasks, scheduledTask);
                        updateArray($scope.masterLicense.license_scheduled_tasks, scheduledTask);
                        $state.go('internal.licensing.license.scheduledtask.details', { licenseCategoryID: $scope.licenseCategoryID, scheduledTaskID: $scope.scheduledTask.id });
                        $scope.saving = false;
                    })
                });
            }
        }

        $scope.delete = function () {
            $scope.deleting = true;

            if (window.confirm('Are you sure you want to delete this scheduled task?')) {
                LicenseScheduledTasks.delete($scope.scheduledTaskID).then(function () {
                    $scope.deleting = false;
                    $state.go('internal.licensing.license.scheduledtasks', { id: $scope.licenseID, licenseCategoryID: $scope.licenseCategoryID });
                })
            }
            else {
                $scope.deleting = false;
            }
        }

        $scope.copy = function () {
            $scope.copying = true;
            var copiedScheduledTask = angular.copy($scope.scheduledTask);

            copiedScheduledTask.id = undefined;
            copiedScheduledTask.name = 'Copy of ' + $scope.scheduledTask.name;

            //Set verify national registry option
            if (copiedScheduledTask.action_data_exchange == 'verify_national_registry_certification') {
                copiedScheduledTask.action_data_exchange = null;
                copiedScheduledTask.verify_national_registry = true;
            }
            else {
                $scope.scheduledTask.verify_national_registry = false;
            }

            LicenseScheduledTasks.save(copiedScheduledTask).then(function () {
                $scope.copying = false;
                $state.go('internal.licensing.license.scheduledtasks', { id: $scope.licenseID, licenseCategoryID: $scope.licenseCategoryID });
            })
        }

    }])
    ;